import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToSelectCoupon = () => {
  if (process.env.NODE_ENV == "local") {
    router.push({
      name: "MfittSelectCoupon",
    });
  } else {
    nativeHandlerService.openTicket(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}mfitt/select-coupon`
    );
  }
};
